// DEVELOPMENT FUNCTIONS
function clog(text, color = "lightgreen", bgcolor = "black") {
  // console.log("%c"+text,"color:"+color+";background:"+bgcolor+"; font-family: monospace; font-size: 16px;");
}

function ctable(dataObj, isDebugger = false) {
  console.table(dataObj);
  if (isDebugger) { debugger; }
}
// END: DEVELOPMENT FUNCTIONS


function addFormData(formData, key, item, arr) {
  if (typeof item === "object" && item && item.constructor === Array) {
    for (var i = 0; i < item.length; i++) {
      var item2 = item[i];
      var key2 = key + "[" + i + "]";
      if (arr) {
        key2 = key + "[" + key2 + "]";
      }
      addFormData(formData, key2, item2, true);
    }
  } else if (typeof item === "object" && item) {
    for (var key2 in item) {
      var item2 = item[key2];
      if (arr) {
        key2 = key + "[" + key2 + "]";
      }
      addFormData(formData, key2, item2, arr);
    }
  } else {
    formData.append(key, item);
  }
  //    if (window.updateThreshold){
  //     // setShippingMsg()
  //     updateThreshold()
  //   }
}


function filterFunction() {
  var input, filter, ul, li, a, i;
  input = document.getElementById("myInput");
  filter = input.value.toUpperCase();
  div = document.getElementById("sw-dropdown-content");
  a = div.getElementsByTagName("a");
  for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "";
    } else {
      a[i].style.display = "none";
    }
  }
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// START: PUBLICATION CUSTOM SLIDER FUNCTION
// Function to start the autoplay
function publicationAutoplayStart(scrollFunction, scrollDelay) {
  timer = setInterval(scrollFunction, scrollDelay);
  return timer
}

// Function to stop the autoplay
function publicationAutoplayStop(timer) {
  clearInterval(timer);
}

// END: PUBLICATION CUSTOM SLIDER FUNCTION

// start: new footer country switcher
function footerCountrySearch() {
  var input, filter, a, i;
  input = document.querySelector(".sw-country-switcher-footer #myInput");
  filter = input.value.toUpperCase();
  div = document.querySelector(".sw-country-switcher-footer #sw-dropdown-content");
  a = div.getElementsByTagName("a");
  for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "";
    } else {
      a[i].style.display = "none";
    }
  }
}
// end: new footer country switcher

// ======== start: QUICK BUY MODULE FUNCTIONS ===========

function hideLoadingImg() {
  window.onload = function () {
    // for removing loading skeleton images
    const loadingImages = document.querySelectorAll(".sw-loadingSkeleton")
    loadingImages.forEach((img) => {
      img.style.display = 'none'
    })

    // for displaying back arrows on slider
    document.querySelectorAll(".swDynamicSlider").forEach((div) => {
      div.classList.remove("showSwLoader")
    })
  }
}
// hideLoadingImg()

// animate product card slider on first load


// ======== end: QUICK BUY MODULE FUNCTIONS ===========


// ============== Start: SW LP Remove First Class ==============
function hideAccordionContent(a) {
  for (var i = a; i < accordionHeading.length; i++) {
    accordionHeading[i].classList.remove('show');
  }
}
// ============== End: SW LP Remove First Class ==============


// ================= Start: Inter Section Observer  ==========================
function createIntersectionObserver(sectionId, sectionFunction) {
  const swSectionId = document.getElementById(sectionId);
  if (!swSectionId) return; // Guard against missing elements
  
  // Create an IntersectionObserver with the callback and options
  const observer = new IntersectionObserver(function (entries) {
    sectionFunction(entries);
    
    // Check if this is a video element or contains video elements
    const hasVideo = swSectionId.querySelector('video') || 
                     swSectionId.tagName === 'VIDEO' ||
                     sectionId.includes('video') || 
                     sectionId.includes('player');
    
    // Only unobserve non-video elements when they enter viewport
    if (!hasVideo && entries[0].isIntersecting) {
      observer.unobserve(swSectionId);
    }
  }, { threshold: 0, rootMargin: "300px" });

  observer.observe(swSectionId);
}
// ================= End: Inter Section Observer  ==========================

// ================= Start: Delete Cookie  ==========================
function deleteCookie(cookieName) {
  // Set the cookie's expiration date to a date in the past
  document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}
// ================= End: Delete Cookie  ============================
